module.exports = __webpack_public_path__ + "static/img/anxun11.7a3e9b98.jpg";